import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LogService } from 'src/app/services/common/log.service';
import { environment } from 'src/environments/environment';
import { IdentitableButtonEnum } from '../subscription-tables/desktop/subscription-table-desktop.component';
import { ProductLevel } from '../product-hero/product-hero.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user/user.service';
import { User } from 'src/app/interfaces/user';

@Component({
  selector: 'app-pitpat-page',
  templateUrl: './pitpat-page.component.html',
  styleUrls: ['./pitpat-page.component.scss']
})
export class PitPatPageComponent implements OnInit, OnDestroy {

  public pricingPlans = environment.stripePlans;
  public IdentitableButtonEnum = IdentitableButtonEnum;
  public desktopViewVisible: boolean;
  public productLevels = ProductLevel;
  public unboxingVideoUrl: SafeResourceUrl;
  public pitPatAdVideoUrl: SafeResourceUrl;

  private _subs: Subscription[] = [];

  constructor(
    private _breakpointObserver: BreakpointObserver,
    private _checkoutService: CheckoutService,
    private _logService: LogService,
    private _sanitizer: DomSanitizer,
    private userService: UserService
  ) { 
    this.unboxingVideoUrl = this._sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/raia4d-ObFU");
    this.pitPatAdVideoUrl = this._sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/oLTM6dmjLGQ?si=u4ZQ0JhReEFOWsEg");
  }

  ngOnInit() {
    this.handleHeaderElementVisibility();
  }

  ngOnDestroy() {
    this._subs.forEach(it => it.unsubscribe());
  }

  public buyPitPat() {
    this.userService.getMe().subscribe((userResponse: User) => {
      if (this.userService.isUserAlertOrFind(userResponse.productType)) {
        this.checkout(this.pricingPlans.pitPatGpsTracker);
      } else {
        this.checkout(this.pricingPlans.pitPatGpsTracker, this.pricingPlans.identiAlertAnnual);
      }
    });
  }

  private checkout(planId: string, secondPlanId?: string) {
    this._checkoutService.checkout(secondPlanId ? [planId,secondPlanId] : [planId]).subscribe(
      () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      (err) => {
        this._logService.error('an error occurred: ', err);
      }
    );
  }

  private handleHeaderElementVisibility() {
    this._subs.push(
      this._breakpointObserver
      .observe(['(min-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        this.desktopViewVisible = state.matches;
      })
    );
  }
}
